import classNames from '../../utils/classNames'
import { numberWithCommas } from '../../utils/number'
import type { AmountInputProps } from '../wallet-management/amount-input'

interface AmountSelectorProps extends Pick<
  AmountInputProps,
  'amount' | 'setAmount'
> {
  amounts: number[]
}

const AmountSelector = ({
  amount,
  setAmount,
  amounts,
}: AmountSelectorProps) => {
  return (
    <div className="grid grid-cols-3 gap-2 mb-3">
      {amounts.map((item, index) => (
        <button
          onClick={() => setAmount(item)}
          className={classNames(
            'relative text-sm py-2 rounded-md border border-solid transition-all duration-200 xl:text-base xl:py-3',
            'dark:bg-[#181818] dark:border-[rgba(255,255,255,0.10)] dark:rounded-lg',
            amount === item
              ? 'deposit-chip-active border-highlight text-highlight dark:!border-[#f5c542] dark:!text-[#f5c542] dark:shadow-[0_0_14px_rgba(245,197,66,0.13)]'
              : 'border-secondary-txt-20 text-txt',
          )}
          key={index}>
          ${numberWithCommas(item)}
        </button>
      ))}
    </div>
  )
}

export default AmountSelector
